{
  "title": "Нам не вдалось знайти сторінку",
  "body": "Будь ласка, перевірте правильність введеної адреси та спробуйте знову"
}
